export default __webpack_public_path__ + "static/media/pdf.bb1df9d4.png";